import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import {Label3} from "@irati/ui/src/Labels"

import Dot from "../Dot"

interface Props {
  margin?: string,
  bold: boolean,
  uppercase: boolean,
  center?: boolean,
  backgroundColor?: string,
  isWhiteText?: boolean
}

export const Container = styled(Label3).attrs<Props>({
  bold: true,
  uppercase: true
})`
  ${({center}) => center && "text-align: center;"}
  background-color: ${({backgroundColor}) => backgroundColor || greys.light};
  color: ${({isWhiteText}) => isWhiteText ? greys.white : greys.black};
  padding: 5px 10px;
  border-radius: ${({theme}) => theme.border.radius.medium};
  white-space: nowrap;
  ${({margin}) => margin && `margin: ${margin};`}
`

export const StyledDot = styled(Dot)`
  margin-left: 7px;
`
